import React, { useState } from 'react';
import loginImage from '../assets/images/login-image.png';
import logo from '../assets/images/logo-1.svg';
import { useLocation, useNavigate } from 'react-router-dom';

const Signup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || ''; // Email passed from the Register page
  
  // State for displaying success or error messages
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);

  // Handle Send OTP
  const handleSendOtp = async (email: string) => {
    if (!email) {
      setMessage({ text: 'Please provide a valid email!', type: 'error' });
      return;
    }

    try {
      const response = await fetch('https://pamsapi.vofoxsolutions.com/api/Account/generate-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Set the correct Content-Type
        },
        body: JSON.stringify({ email }) // Send the email as a JSON body
      });

      if (response.ok) {
        const responseData = await response.json();
        setMessage({ text: 'OTP sent successfully!', type: 'success' });
        setTimeout(() => {
          navigate('/signup-otp', { state: { email } }); // Pass email to OTP verification page
        }, 1500); // Wait for 1.5 seconds before navigating
      } else {
        const errorData = await response.json();
        console.error('Error generating OTP:', errorData);
        setMessage({ text: 'Failed to generate OTP!', type: 'error' });
      }
    } catch (error) {
      console.error('Error during OTP generation:', error);
      setMessage({ text: 'Something went wrong while generating OTP!', type: 'error' });
    }
  };

  return (
    <div className="content-wrapper">
      <main>
        <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
          <div>
            <div className="flex flex-wrap items-center">
              {/* Left Image Section */}
              <div className="hidden w-full h-full lg:block lg:w-1/2">
                <div className="px-26 py-17.5 text-center">
                  <span className="mt-15 inline-block">
                    <img
                      className="h-full w-full object-cover"
                      src={loginImage}
                      alt="illustration"
                    />
                  </span>
                </div>
              </div>

              {/* Right Form Section */}
              <div className="w-full lg:w-1/2">
                <div className="w-full lg:w-3/4 p-4 sm:p-12.5 xl:p-17.5 m-auto">
                  <a className="mb-8 inline-block" href="/">
                    <img src={logo} alt="Logo" />
                  </a>

                  <h2 className="mb-9 mt-3 text-3xl font-semibold text-dark">
                    Sign up to your account
                  </h2>

                  {/* Signin Form */}
                  <form>
                    {/* Email Input */}
                    <div className="mb-6">
                      <div className="relative">
                        <input
                          type="email"
                          value={email}
                          placeholder="Enter your email"
                          className="w-full rounded-lg bg-slate-50 py-4 pl-6 pr-10 outline-none focus:border-blue focus-visible:shadow-none"
                          disabled // Disable input since email is pre-filled
                        />
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="mb-5">
                      <input
                        type="button"
                        value="Send OTP"
                        onClick={() => handleSendOtp(email)} // Call handleSendOtp with email
                        className="w-full cursor-pointer bg-blue-600 shadow-lg shadow-blue-300/50 rounded-lg border border-primary p-4 font-medium text-white transition hover:bg-blue-500"
                      />
                    </div>
                  </form>

                  {/* Display Success or Error Message */}
                  {message && (
                    <div
                      className={`mt-4 p-4 rounded-lg text-white ${
                        message.type === 'success' ? 'bg-green-500' : 'bg-red-500'
                      }`}
                    >
                      {message.text}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Signup;
